// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"3168": "2c8323b1","4777": "13f44d2c","6938": "0a49cdea","7124": "9fe3b25c","7523": "e5b33855","7874": "2c7a2371","791": "9bfd37a3",}[chunkId] + ".css"
}